
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/richiesta-catalogo",
      function () {
        return require("private-next-pages/richiesta-catalogo/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/richiesta-catalogo"])
      });
    }
  